import React from 'react';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "../../CSS/MulticloudSection.css";

// Multicloud Logos
const AWS = 'https://cdn.redinet.us/Home/AWS color.webp';
const Huawei2 = 'https://cdn.redinet.us/Home/HuaweiCloud2.webp';
const Google2 = 'https://cdn.redinet.us/Home/GoogleCloud2.webp';
const Azure2 = 'https://cdn.redinet.us/Home/Azure2.webp';

export const MulticloudSection = () => {
  const [t] = useTranslation('common');

  const cloudPartners = [
    {
      id: 'azure',
      title: 'Microsoft Azure',
      image: Azure2,
      alt: 'Microsoft Azure Cloud',
      text: t('home.azure'),
      link: '/Microsoft'
    },
    {
      id: 'aws',
      title: 'Amazon Web Services',
      image: AWS,
      alt: 'AWS Cloud',
      text: t('home.amazon'),
      link: '/AWS'
    },
    {
      id: 'google',
      title: 'Google Cloud',
      image: Google2,
      alt: 'Google Cloud',
      text: t('home.google'),
      link: '/google'
    },
    {
      id: 'huawei',
      title: 'Huawei Cloud',
      image: Huawei2,
      alt: 'Huawei Cloud',
      text: t('home.huawei'),
      link: ''
    }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="multicloud-section-container">
      <div className="container">
        {/* Section Header */}
        <div className="multicloud-header">
          <h2 className="multicloud-main-title">
            {t('home.aliado')} <span className="multicloud-highlight-text">{t('home.multinubes')}</span>
          </h2>
          <p className="multicloud-subtitle">
            {t('home.representantes')}
          </p>
          <hr className="multicloud-divider" />
        </div>

        {/* Carousel / Cards List */}
        <div className="multicloud-slider-wrapper">
          <Slider {...sliderSettings} className="multicloud-slider">
            {cloudPartners.map((partner) => (
              <div key={partner.id} className="multicloud-card-wrapper">
                <div className="multicloud-card">
                  {/* Uniform Logo Container */}
                  <div className="multicloud-logo-box">
                    <img
                      src={partner.image}
                      alt={partner.alt}
                      className="multicloud-logo-img"
                    />
                  </div>

                  {/* Card Content */}
                  <div className="multicloud-card-content">
                    <h3 className="multicloud-card-title">{partner.title}</h3>
                    <p className="multicloud-card-desc">{partner.text}</p>

                    {/* Aligned Action Button */}
                    <div className="multicloud-btn-container">
                      <Link to={partner.link} className={`multicloud-action-btn ${partner.link === '' ? 'disabled' : ''}`}>
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default MulticloudSection;
